
function activeSubnav() {
    const elements = document.querySelectorAll('.jsToggle span');
    if (!elements.length) return;

    document.querySelectorAll('.hNav .hNavBox, .hNav .subBox').forEach(el => el.style.display = 'flex');
    elements.forEach(el => el.addEventListener('click', handleClickSubnav));
}

function handleClickSubnav(e) {
    const elm = e.target;
    const nextSibling = elm.nextElementSibling;
    const parentElm = elm.parentElement;
    const overlay = document.getElementById('overlay');

    if (window.innerWidth <= 768) {
        elm.classList.toggle('active');
        nextSibling?.classList.toggle('slideDown');
    } else {
        const siblings = [...parentElm.parentNode.children];
        siblings.forEach(sibling => {
            if (sibling !== parentElm) {
                sibling.classList.remove('active');
                sibling.querySelector('span')?.classList.remove('active');
            }
        });

        const isActive = parentElm.classList.toggle('active');
        overlay.classList.toggle('active01', isActive);
        elm.classList.toggle('active', isActive);
    }
}

activeSubnav();